<template>
  <RevDrawer
    :name="MODAL_NAMES.ABOUT_BATTERY"
    :title="i18n(translations.aboutBatteryHealth)"
  >
    <template #body>
      <div class="mb-24">
        <RevIllustration
          alt=""
          class="rounded-md w-full object-cover"
          :height="240"
          role="presentation"
          :src="illustration"
          :width="327"
        />
      </div>

      <h3 class="heading-2 mb-16 text-balance text-center">
        {{ i18n(translations.aboutBatteryHealth) }}
      </h3>

      <p class="mb-24">
        {{ i18n(translations.content1) }}
      </p>

      <p class="mb-24">
        {{ i18n(translations.content2) }}
      </p>

      <RevInfoBlock
        v-if="isSmartphoneCategory"
        class="mb-24"
        :icon="IconInfo"
        :title="i18n(translations.infoTitle)"
        variant="info"
      >
        <p>{{ i18n(translations.infoContent) }}</p>
        <RevLink v-if="link" target="_blank" :to="link">{{
          i18n(translations.learnMore)
        }}</RevLink>
      </RevInfoBlock>

      <BatteryFaq :has-external-borders="false" />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed } from 'vue'

import type { LinkInternal } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconInfo } from '@ds/icons/IconInfo'

import { LINKS } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/NewBatteryModal/NewBatteryModal.constants'
import BatteryFaq from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/NewBatteryModal/components/BatteryFaq/BatteryFaq.vue'

import { MODAL_NAMES } from '../../Product-JP.constants'

import translations from './AboutBatteryModal.translations'

const { illustration, isSmartphoneCategory } = defineProps<{
  illustration: string
  isSmartphoneCategory: boolean
}>()

const i18n = useI18n()

const {
  market: { countryCode },
} = useMarketplace()

const resolveLocalizedRoute = useRouteLocationWithLocale()

const link = computed(() => {
  return LINKS[countryCode]
    ? resolveLocalizedRoute(LINKS[countryCode] as LinkInternal)
    : null
})
</script>
